import { render, staticRenderFns } from "./WeekForTime.vue?vue&type=template&id=40b41d86&"
import script from "./WeekForTime.vue?vue&type=script&lang=js&"
export * from "./WeekForTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports